import React from 'react';
import '../../App.css';
import Footer from '../Footer';

function Store() {
  return (
    <>
      <div className='store-header-image'>
        <h1>Store</h1>
      </div>

      <div className='main-content-container'> 
        
      </div>

      <Footer />
    </>
  );
}

export default Store;